import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ overlayColor = '#fff', align = 'center', children }) => {
	useEffect(() => {
		let offset = window.pageYOffset;
		document.body.classList.add("modal-status__open");
		document.body.style.top = `-${offset}px`;

		return () => {
			document.body.classList.remove("modal-status__open");
			window.scrollTo(0, offset);
		}
	}, []);

	return (
		<div className="overlay-background" style={{ background: overlayColor }}>
			<div className={`modal-block bg-white rounded p-3 text-${align}`}>
				{children}
			</div>
		</div>
	);
}

export const ModalClose = ({ handleCloseClick }) => {
	return (
		<div className="text-right">
			<button type="button" className="close" aria-label="Close" onClick={handleCloseClick}>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	);
}

export const ModalText = ({ message }) => {
	if (message) {
		return (
			<div className="modal-block__text">
				{message}
			</div>
		);
	} else {
		return null;
	}
}

export const ModalButton = ({ label, type = 'primary', disabled, handleButtonClick }) => {
	return (
		<button className={`modal-block__button btn btn-${type} py-1 px-3 my-2 mr-1`} disabled={disabled} onClick={handleButtonClick}>
			{label}
		</button>
	);
}

export default Modal;